import { GridColDef } from '@mui/x-data-grid-pro';
import ActionsCell from './components/ActionsCell';
import MultipleCell from './components/AdvertisersCell';
import ClientNameCell from './components/ClientNameCell';
import StatusCell from './components/StatusCell';
import WhitelabelCell from './components/WhitelabelCell';

const COLUMNS: GridColDef[] = [
  {
    field: 'name',
    headerName: 'Client Name',
    display: 'flex',
    renderCell: ClientNameCell,
    flex: 2,
  },
  {
    field: 'whitelabel',
    headerName: 'Whitelabel',
    display: 'flex',
    renderCell: WhitelabelCell,
    align: 'center',
    headerAlign: 'center',
    flex: 1.5,
    sortable: false,
  },
  {
    field: 'advertisers',
    headerName: 'Advertisers',
    display: 'flex',
    renderCell: MultipleCell,
    align: 'center',
    headerAlign: 'center',
    flex: 3,
    sortable: false,
  },
  {
    field: 'agencies',
    headerName: 'Agencies',
    display: 'flex',
    renderCell: MultipleCell,
    align: 'center',
    headerAlign: 'center',
    flex: 3,
    sortable: false,
  },
  {
    field: 'isActive',
    headerName: 'Status',
    flex: 1,
    align: 'center',
    headerAlign: 'center',
    display: 'flex',
    renderCell: StatusCell,
    sortable: false,
  },
  {
    field: 'actions',
    flex: 1,
    headerName: 'Actions',
    align: 'center',
    headerAlign: 'center',
    display: 'flex',
    renderCell: ActionsCell,
    sortable: false,
  },
];

export default COLUMNS;
